import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigProvider, App as AntApp } from 'antd';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ConfigProvider>
          <AntApp>
            <App />
          </AntApp>
      </ConfigProvider>
    </ThemeProvider>
  </React.StrictMode>
);
reportWebVitals();